import { render, staticRenderFns } from "./WidgetUrl.vue?vue&type=template&id=6b33f410"
import script from "./WidgetUrl.vue?vue&type=script&lang=js"
export * from "./WidgetUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports